import { SimpleGrid, useRadioGroup } from '@chakra-ui/react'
import { ATTENDANCE_CLASSIFICATIONS_OPTIONS } from 'Attendances/constants/variables'
import ClassificationCard from './components/ClassificationCard'

type ClassificationPickerProps = {
  watch: any
  setValue: any
  columns?: any
  gap?: number
  withoutDescription?: boolean
}

export default function ClassificationPicker({
  watch,
  setValue,
  columns = 1,
  gap = 4,
  withoutDescription = false,
}: ClassificationPickerProps) {
  const { value, getRadioProps } = useRadioGroup({
    value: watch('classification') || '',
    onChange: (value) => setValue('classification', value),
  })
  return (
    <SimpleGrid columns={columns} gap={gap}>
      {ATTENDANCE_CLASSIFICATIONS_OPTIONS.map((classification) => (
        <ClassificationCard
          key={classification.label}
          isClassificationSelected={value === classification.value}
          withoutDescription={withoutDescription}
          {...classification}
          {...getRadioProps({ value: classification.value })}
        />
      ))}
    </SimpleGrid>
  )
}
